// extracted by mini-css-extract-plugin
export default {"container":"styles_container__SmEab","menu":"styles_menu__Nrynj"};